module.exports = __webpack_public_path__ + "img/ok_kwadranten_correct.e0f069ce.png";